import { ElementType, ReactElement, useState } from 'react';
import { DropdownItem, StyledDropdownMenu } from './styles';
import { Dropdown } from 'react-bootstrap';
import { MenuOption } from './menuOptions';

export type ComponentOptionI = {
  component?: ElementType;
  onClick?: () => void;
  icon: ReactElement;
  label: string;
  noFill?: boolean;
  'data-testid': string;
};

export type ComponentOption = {
  type: 'component';
  details: ComponentOptionI;
};

export type DividerOption = {
  type: 'divider';
};

export type OptionI = ComponentOption | DividerOption;

type ContextMenuI = {
  options: Array<OptionI>;
  menuButton?: ElementType;
  'data-testid': string;
};

const ContextMenu = ({
  menuButton,
  options,
  ...rest
}: ContextMenuI): ReactElement => {
  const [isOpened, setIsOpened] = useState(false);

  return (
    <Dropdown
      data-testid={rest['data-testid']}
      onToggle={() => setIsOpened && setIsOpened(!isOpened)}
    >
      <Dropdown.Toggle
        variant="success"
        id="dropdown-basic"
        as={menuButton}
        isOpened={isOpened}
      />
      <Dropdown.Menu as={StyledDropdownMenu}>
        {options.map((option, index) => {
          if (option.type === 'divider') {
            return <Dropdown.Divider key={index} />;
          }
          const { details } = option;
          return (
            <DropdownItem
              key={details.label}
              data-testid={details['data-testid']}
              as={details.component || MenuOption}
              onClick={details.onClick}
              noFill={details.noFill}
              icon={details.icon}
              label={details.label}
            />
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ContextMenu;
